import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationDriveTraffic = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationDriveTraffic',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70369)",
    fillRule: "evenodd",
    d: "M43.46 100V10s-.07-5.06 6.4-5.06c6.43 0 6.47 5.06 6.47 5.06v89.92l-12.87.08Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#00A1BC",
    fillRule: "evenodd",
    d: "M56.33 68.08c-10.39 0-12.87 5.12-12.87 5.12v-6.48h12.87v1.36ZM56.33 37.42c-10.39 0-12.87 5.12-12.87 5.12v-6.48h12.87v1.36Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70369)",
    fillRule: "evenodd",
    d: "m5.87 24.19 13.52-9.97h60.35c2.21 0 4 1.79 4 4v15.16c0 2.21-1.79 4-4 4H19.39L5.87 27.41a2.005 2.005 0 0 1 0-3.22Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70369)",
    fillRule: "evenodd",
    d: "m93.94 58.17-14.28 9.9H19.78c-2.21 0-4-1.79-4-4V48.99c0-2.21 1.79-4 4-4h59.87l14.28 9.9c1.16.79 1.16 2.49.01 3.28Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70369",
    x1: 36.377,
    x2: 66.193,
    y1: 53.872,
    y2: 51.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.037,
    stopColor: "#00C9FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.794,
    stopColor: "#FFE2B9"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70369",
    x1: 40.202,
    x2: 53.541,
    y1: 41.292,
    y2: 4.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.156,
    stopColor: "#9E58FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.997,
    stopColor: "#FFDFD8"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70369",
    x1: 46.133,
    x2: 61.295,
    y1: 77.745,
    y2: 36.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.156,
    stopColor: "#9E58FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.997,
    stopColor: "#FFDFD8"
  }))));
};
ColoredIllustrationDriveTraffic.displayName = 'ColoredIllustrationDriveTraffic';
export default withProvisionalOverrideFromContext(ColoredIllustrationDriveTraffic);
//# sourceMappingURL=index.js.map